<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <h3>Barkod Taraması</h3>
        </div>
      </div>
      <div class="card-body">

        <div>
          <small class="text-muted">Fazlalık barkodları taratarak listeleyebilir ve silebilirsiniz.</small>
        </div>
        <div class="text-sm mb-4" v-if="companies.length > 0">
          <b-form-group class="mb-0">
            <b-form-select v-model="company" :options="companies" />
          </b-form-group>
        </div>
        <b-form-group class="mb-0">
          <b-form-input
            v-model="barcode"
            placeholder="Barkod Giriniz"
            @input="addBarcode"
          ></b-form-input>
        </b-form-group>

        <div v-if="barcodes.length > 0">
          <div class="d-flex justify-content-between">
            <b-button variant="danger" class="my-3" @click="barcodes = []"
              >Barkodları Temizle</b-button
            >

            <b-button
              variant="success"
              :disabled="loading"
              class="my-3"
              @click="cPage=1; search();"
            >
              <div class="spinner-border" role="status" v-if="loading">
                <span class="sr-only">Loading...</span>
              </div>
              <template v-else> Ara </template>
            </b-button>
          </div>
          <span
            v-for="(barcode, index) in barcodes"
            v-bind:key="index"
            class="mr-5 mb-5"
          >
            {{ barcode }}
            <button
              class="btn btn-danger btn-sm"
              @click="barcodes.splice(index, 1)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
        </div>
      <div v-if="products.length>1">
        <div class="mt-2 text-right">
          <small class="text-darker">Toplam {{ infos.barcodeCount }} Barkod Tarandı!</small> <br>
          <small class="text-success">{{ infos.trueMatch }} Ürün Eşleşti!</small> <br>
          <small class="text-danger">{{ infos.falseMatch }} Ürün Eşleşmedi!</small>
        </div>
        <div class="text-right my-3">
          <button class="btn btn-danger" @click="deleteAll">Eşleşmeyenleri Sil</button>
        </div>
        <b-table
            ref="table"
            class="my-2"
            :fields="fields"
            :items="products"
        >

          <template v-slot:cell(matched)="data">
            <div class="badge badge-success" v-if="data.item.matched">Eşleşti</div>
            <div class="badge badge-danger" v-else>EŞLEŞMEDİ!</div>
          </template>
        </b-table>
        <Pagination :c-page="cPage" @changePage="changePage" :last_page="last_page" :refresh-table="refreshTable" />

      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Pagination from './Pagination';

export default {
  components: { Pagination },
  data() {
    return {
      barcode: '',
      barcodes: [],
      cPage:1,
      last_page:1,
      products: [],
      infos:{},
      company: null,
      loading: false,
      fields: [
        {
          key: 'name',
          label: 'İsim',
        },
        {
          key: 'barcode',
          label: 'Barkod',
        },
        {
          key:'matched',
          label:'Eşleşme'
        },
        {
          key: 'actions',
          label: '',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['companies']),
  },
  methods: {
    ...mapActions(['getSurplusProducts','deleteAllSurpluses']),
    addBarcode() {
      this.barcodes.push(this.barcode);
    },
    deleteAll(){
      this.deleteAllSurpluses({
        company_id:this.company,
        barcodes:this.barcodes
      }).then(res=>{
        this.success('Fazlalık Ürünler Başarıyla Silindi!')
        this.products=[]
        this.barcodes=[]
      }).catch(err=>{
        this.error('Bir Hata İle Karşılaşıldı!')
      })
    },
    refreshTable(){
      this.$refs.table.refresh()
    },
    changePage(e){
      this.cPage=e;
      this.search()
    },
    search() {
      if (this.company == null) {
        this.error('Lütfen Bayi Seçin!');
        return;
      }
      this.loading=true
      this.getSurplusProducts({
        company_id: this.company,
        barcodes: this.barcodes,
        page:this.cPage
      })
        .then((res) => {
          let services = res.data.services.data;
          this.products = services.map((service) => ({
            name: service.name,
            barcode: service.barcode,
            matched:service.matched
          }));
          this.infos={
            barcodeCount:res.data.barcodeCount,
            falseMatch:res.data.falseMatch,
            trueMatch:res.data.trueMatch,
            totalProducts:res.data.totalProducts,
          }
          this.last_page=res.data.services.last_page
        })
        .catch((err) => {
          console.log(err)
          this.error('HATA!');
        }).finally(res=>{

          this.loading=false
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
